"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TagStyled = _styledComponents["default"].div.withConfig({
  displayName: "Tag__TagStyled",
  componentId: "vn8l0z-0"
})(["display:inline-block;align-content:center;margin:4px 10px;> div{display:inline-block;vertical-align:middle;}.tag-selector{position:relative;height:22px;width:22px;border-radius:4px;background-color:#a7b6d6;box-shadow:0 2px 16px 0 rgba(0,0,0,0.16);display:none;margin-right:7px;}.tag-body{padding:4px 10px;border-radius:5px;font-size:12px;font-weight:bold;color:#fff;background-color:#3d77f7;white-space:nowrap;}&.selection-on{& .tag-selector{display:inline-block;}& > div{cursor:pointer;}&.selected{& .tag-selector{background-color:#3d77f7;&:after{content:'';height:5px;width:13px;border-bottom:2px solid #fff;border-left:2px solid #fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-69%) rotate(-45deg);}}}}"]);

var Tag = function Tag(_ref) {
  var id = _ref.id,
      title = _ref.title,
      color = _ref.color,
      type = _ref.type,
      onClickProp = _ref.onClick,
      className = _ref.className;

  var onClick = function onClick() {
    var tag = {
      id: id,
      title: title,
      color: color,
      type: type
    };
    if (onClickProp) onClickProp({
      target: {
        id: id,
        value: tag
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement(TagStyled, {
    className: "tag ".concat(className || ''),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-selector"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-body",
    style: {
      backgroundColor: "#".concat(color),
      color: (0, _utils.getContrastYIQ)(color)
    }
  }, title));
};

Tag.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  title: _propTypes["default"].string,
  color: _propTypes["default"].string,
  type: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string
};
Tag.defaultProps = {
  id: 0,
  color: '3D77F7',
  title: '-',
  type: '',
  className: '',
  onClick: function onClick() {
    console.log('Not yet implemented');
  }
};
var _default = Tag;
exports["default"] = _default;